module.exports = __webpack_public_path__ + "static/media/task8Planet3.9faa48c5.png";